import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE } from "./importBillPayments.constants";

const ImportBillPayments = Loadable(
  lazy(() =>
    import("./importBillPayments").then(({ ImportBillPayments }) => ({
      default: ImportBillPayments,
    }))
  )
);

// const ImportInvoicePayments = Loadable(
//   lazy(() =>
//     import("./importInvoicePayments").then(({ ImportInvoicePayments }) => ({
//       default: ImportInvoicePayments,
//     }))
//   )
// );

export const ImportBillPaymentsRoutes = [
    {
        path: `${APP_FILE_IMPORT_BILL_PAYMENTS_ROUTE}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[]} allowFullAccess>
            <ImportBillPayments />
          </AuthorizedRoute>
        ),
      },
      // {
      //   path: `${APP_FILE_IMPORT_INVOICE_PAYMENTS_ROUTE}`,
      //   exact: true,
      //   element: (
      //     <AuthorizedRoute moduleKeys={[]} allowFullAccess>
      //       <ImportInvoicePayments />
      //     </AuthorizedRoute>
      //   ),
      // },
];
